import { render } from "./bulk-transaction-upload.vue?vue&type=template&id=087fde16"
import script from "./bulk-transaction-upload.vue?vue&type=script&lang=js"
export * from "./bulk-transaction-upload.vue?vue&type=script&lang=js"

import "./bulk-transaction-upload.vue?vue&type=style&index=0&id=087fde16&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__